<era-device-os-update-status-ui [osUpdateStatus]="osUpdateStatus$ | async"> </era-device-os-update-status-ui>